import { routes } from "../../../constants";
import { baseRouteMaker } from "../../../constants/routeConsts";
import i18n from "../../../i18n/i18n";

export const useAddonsAndSponsorshipsMenuUtils = (t) => {
  const tempMenuGroup = [];

  /* menuItemAddon */
  const menuItemAddon = {
    id: "addons-and-sponsorships",
    title: t("Modules.addOns.addon"),
    url: baseRouteMaker(routes.ADDONS_AND_SPONSORSHIPS_ADDON),
  };
  tempMenuGroup.push(menuItemAddon);
  /* menuItemAddon */

  /* menuItemAddonPlanHistory */
  const menuItemAddonPlanHistory = {
    id: "addons-and-sponsorships-plan-history",
    title: t("Modules.addOns.addHistory"),
    url: baseRouteMaker(routes.ADDONS_AND_SPONSORSHIPS_ADDON_PLAN_HISTORY),
  };
  tempMenuGroup.push(menuItemAddonPlanHistory);
  /* menuItemAddonPlanHistory */

  /* menuItemAddOrganizationSponsorshipHistory */
  const menuItemAddOrganizationSponsorshipHistory = {
    id: "add-organization-sponsorships-plan-history",
    title: i18n.t("Modules.addOns.addOrganizationSponsorshipHistory"),
    url: baseRouteMaker(
      routes.ADDONS_AND_SPONSORSHIPS_ORGANIZATION_SPONSORSHIP_HISTORY
    ),
  };
  tempMenuGroup.push(menuItemAddOrganizationSponsorshipHistory);
  /* menuItemAddOrganizationSponsorshipHistory */

  /* menuItemAddPushNotificationHistory */
  const menuItemAddPushNotificationHistory = {
    id: "add-push-notification-plan-history",
    title: i18n.t("Modules.addOns.addPushNotificationHistory"),
    url: baseRouteMaker(
      routes.ADDONS_AND_SPONSORSHIPS_PUSH_NOTIFICATION_HISTORY
    ),
  };
  tempMenuGroup.push(menuItemAddPushNotificationHistory);
  /* menuItemAddPushNotificationHistory */

  return tempMenuGroup;
};
